import React from 'react'
import Bredcrumb from '../Common/Bredcrumb'

const SportsMeet = () => {
  return (
    <>
      <Bredcrumb  title="Sports Meet"  />
      <section className='mt-4'>
            <div class="container">
                <div class="row">
                <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-01.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-02.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-03.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-04.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-05.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-06.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-07.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-08.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-09.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-10.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-11.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-12.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-13.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-14.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-15.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-16.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-17.png" alt="..." />                                           
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-18.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-26.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-27.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-28.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/visithospital-29.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-01.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-02.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-03.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-04.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-05.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-06.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-07.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-08.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-09.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-10.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-11.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-12.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-13.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-14.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-15.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-17.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-18.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-19.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-20.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-21.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-22.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-23.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-24.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-25.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-26.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-27.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-28.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-29.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-30.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-31.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-32.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-33.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-34.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-35.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-36.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-37.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-38.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-39.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-40.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-41.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-42.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-43.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-44.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-45.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-46.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-47.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-48.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-3">
                        <div className="gallary-block gallary_block_new">
                            <div className="position-relative">
                                <img src="img/content/SportsFeild-49.png" alt="..." />                                           
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </section>
    </>
  )
}

export default SportsMeet
